export enum esdhJournalingStatus {
  UNDEFINED = 'undefined',
  NOT_PROCESSED = 'not_processed',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  COMPLETED = 'completed',
}
